import type { TeamRecord, TeamStatus } from '../types';

export const getTeamStatus = (team: TeamRecord): TeamStatus => team.status ?? 'Active';

export const isTeamDisabled = (team: TeamRecord) => getTeamStatus(team) === 'Disabled';
